// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__94uF3","span_footer":"styles_span_footer__BxO2P","saibamais":"styles_saibamais__3HcLn"};